var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamMemberActions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3.33333,
    height: 15,
    viewBox: "0 0 3.33333 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07741 2.25592C1.23369 2.4122 1.44565 2.5 1.66667 2.5C1.88768 2.5 2.09964 2.4122 2.25592 2.25592C2.4122 2.09964 2.5 1.88768 2.5 1.66667C2.5 1.44565 2.4122 1.23369 2.25592 1.07741C2.09964 0.921131 1.88768 0.833333 1.66667 0.833333C1.44565 0.833333 1.23369 0.921131 1.07741 1.07741C0.921131 1.23369 0.833333 1.44565 0.833333 1.66667C0.833333 1.88768 0.921131 2.09964 1.07741 2.25592Z",
    stroke: "#6B7280",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07741 8.08926C1.23369 8.24554 1.44565 8.33333 1.66667 8.33333C1.88768 8.33333 2.09964 8.24554 2.25592 8.08926C2.4122 7.93298 2.5 7.72101 2.5 7.5C2.5 7.27899 2.4122 7.06703 2.25592 6.91075C2.09964 6.75446 1.88768 6.66667 1.66667 6.66667C1.44565 6.66667 1.23369 6.75446 1.07741 6.91075C0.921131 7.06703 0.833333 7.27899 0.833333 7.5C0.833333 7.72101 0.921131 7.93298 1.07741 8.08926Z",
    stroke: "#6B7280",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07741 13.9226C1.23369 14.0789 1.44565 14.1667 1.66667 14.1667C1.88768 14.1667 2.09964 14.0789 2.25592 13.9226C2.4122 13.7663 2.5 13.5543 2.5 13.3333C2.5 13.1123 2.4122 12.9004 2.25592 12.7441C2.09964 12.5878 1.88768 12.5 1.66667 12.5C1.44565 12.5 1.23369 12.5878 1.07741 12.7441C0.921131 12.9004 0.833333 13.1123 0.833333 13.3333C0.833333 13.5543 0.921131 13.7663 1.07741 13.9226Z",
    stroke: "#6B7280",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMemberActions);
export default __webpack_public_path__ + "static/media/team-member-actions.22d260fd892031deb14bc5146c3c965b.svg";
export { ForwardRef as ReactComponent };